<template>
  <div class="page page--contact contact">
    <div class="page__block">
      <h2>{{ $t('contact.title') }}</h2>
      <p>{{ $t('contact.description') }}</p>
      <p><b>Huur een Stuur BV</b></p>
      <table>
        <tr>
          <td>{{$t('contact.address')}}</td>
          <td><p>E3-Laan 87<br>9800 {{ $t('general.Deinze') }}<br>{{ $t('general.be') }}</p></td>
        </tr>
        <tr>
          <td>{{$t('contact.tel')}}</td>
          <td><p><a href="tel:+3293896250">+32 9 389 62 50</a></p></td>
        </tr>
        <tr>
          <td>{{$t('contact.email')}}</td>
          <td><a href="mailto:contact@billo.be">contact@billo.be</a></td>
        </tr>
        <tr>
          <td>{{$t('contact.vat')}}</td>
          <td>BE 0450 825 019</td>
        </tr>
        <tr>
          <td>{{$t('contact.companynr')}}</td>
          <td>0450 825 019</td>
        </tr>
      </table>
    </div>
    <div class="page__block">
      <h2>{{ $t('contact.complaint') }}</h2>
      <div v-html="$t('contact.complaints')"></div>
      <div v-html="$t('contact.complaints2')"></div>
    </div>
    <div class="page__block">
      <h2>{{$t('partner.texttitle')}}</h2>
      <p>{{$t('partner.text')}} <a target="_blank" :href="$t('partner.link')">{{$t('partner.request')}}</a>{{$t('partner.text2')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",

  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>